import React from "react";
import TabPanel, { TabPanelProps } from "@mui/lab/TabPanel/index";
import DialogContent from "@mui/material/DialogContent";
import styled from "styled-components";

const StyledTabPanel = styled(TabPanel)`
    background: var(--formant-color-primary-steel01);
    overflow-y: auto;
`;

const StyledDialogContent = styled(DialogContent)`
    padding: 0.625rem 0;
`;

interface ITabPanelContentProps {
    children: React.ReactNode;
    value: string;
    tabPanelProps?: Omit<TabPanelProps, "value">;
}

export default function TabPanelContent({
    children,
    value,
    tabPanelProps,
}: ITabPanelContentProps) {
    return (
        <StyledTabPanel value={value} {...tabPanelProps}>
            <StyledDialogContent>{children}</StyledDialogContent>
        </StyledTabPanel>
    );
}
